import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-[68px] rounded-lg bg-lightGray30" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h-[92px] rounded-lg bg-lightGray30" }, null, -1)
const _hoisted_4 = {
  class: "grid gap-2.5",
  style: {"grid-template-columns":"repeat(auto-fit, minmax(150px, 1fr))"}
}
const _hoisted_5 = { class: "flex flex-col gap-1.5 rounded-lg border border-lightGray30 p-3" }


export default /*#__PURE__*/_defineComponent({
  __name: 'PriorityPaymentsSkeleton',
  props: {
    rows: { default: 8 },
    testId: { default: 'priority-payments-skeleton' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex w-full animate-pulse flex-col gap-4",
    "aria-hidden": "true",
    "data-testid": _ctx.testId
  }, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (card) => {
        return _createElementVNode("div", {
          key: card,
          class: "h-[76px] rounded-lg bg-lightGray30"
        })
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          key: row,
          class: "h-9 rounded bg-lightGray30",
          "data-testid": "priority-payments-skeleton-row"
        }))
      }), 128))
    ])
  ], 8, _hoisted_1))
}
}

})